import Destinations from '@/components/Settings/Destinations';
import React from 'react';

const Settings = () => {
  return <Destinations />;
};

export default Settings;
